import { Debounce } from './lib/debounce.js';

export class RenderUtils {
  #global;

  constructor({ global }) {
    this.#global = global;
  }

  get debounce() {
    return new Debounce({ global: this.#global });
  }
}

export const renderUtils = new RenderUtils({
  global: window
})
